import { render } from "./App.vue?vue&type=template&id=136ff52c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=136ff52c&lang=css"

import exportComponent from "D:\\wcb\\www\\clpga_htmlgit\\f_pc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__